var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168 520 c-103 -53 -136 -74 -132 -85 4 -8 10 -15 15 -15 5 0 9 -74 9 -165 l0 -165 260 0 260 0 0 165 c0 91 4 165 9 165 5 0 11 7 15 15 4 11 -30 33 -132 85 -75 38 -144 69 -152 69 -8 0 -77 -31 -152 -69z m265 -26 l107 -55 0 -154 c0 -148 -1 -155 -20 -155 -19 0 -20 7 -20 135 l0 135 -180 0 -180 0 0 -135 c0 -128 -1 -135 -20 -135 -19 0 -20 7 -20 155 l0 154 103 54 c56 30 107 55 112 55 6 1 58 -23 118 -54z m22 -249 c0 -99 -2 -110 -18 -113 -12 -2 -31 10 -52 32 -45 49 -85 49 -131 0 -56 -59 -68 -46 -72 70 -1 55 0 106 2 113 4 11 34 13 138 11 l133 -3 0 -110z m-95 -100 c0 -11 -11 -15 -40 -15 -29 0 -40 4 -40 15 0 11 11 15 40 15 29 0 40 -4 40 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.ce76e53e75f7fd4ee6e9b8edd100a167.svg";
export { ForwardRef as ReactComponent };